import { createFileRoute, redirect } from "@tanstack/react-router"

import { DevDemosRoutePage } from "@/pages/dev/demos-route"

/**
 * Vite `import.meta.env.DEV` only (same as API JWT) — not RBAC. Production build redirects
 * away; if you need dev UIs in a deployed env, add e.g. `requirePermission` here instead.
 */
export const Route = createFileRoute("/_authenticated/settings/dev/demos")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: DevDemosRoutePage,
})
